
import React from 'react';
import { ShimmerTable } from 'react-shimmer-effects';
import { ShimmerBadge } from "react-shimmer-effects";

function ViewAttendanceShimmer({classkey}) {
    return (
        <div className={classkey?classkey:'mt-4'}>
            <div className='flex justify-between'>
                <ShimmerBadge width={150} />
                <ShimmerBadge width={150} />
                <ShimmerBadge width={150} />
            </div>

            <div className='w-full'>  
                <ShimmerTable row={10} col={4} />
            </div>
        </div>
    );
}

export default ViewAttendanceShimmer;